export default __webpack_public_path__ + "static/media/LocationScorerDiagram.4221923b.jpg";